import { memo } from 'react';

import {
  BaseCustomFieldFilterCard,
  type BaseCustomFieldFilterCardProps,
} from '~/components/Filters/CustomFieldFilter/BaseCustomFieldFilterCard';
import { type CustomFieldFilterType } from '~/components/FiltersMenu/types';
import { useGetPrivateCustomFieldOptions } from '~/swr-hooks/customFields/useGetPrivateCustomFieldOptions';

export type PrivateCustomFieldFilterCardProps = {
  customField: CustomFieldFilterType;
} & Omit<BaseCustomFieldFilterCardProps, 'values'>;

export const PrivateCustomFieldFilterCard = memo(({ customField, ...props }: PrivateCustomFieldFilterCardProps) => {
  const { data } = useGetPrivateCustomFieldOptions({
    customFieldId: customField?.id,
  });

  return <BaseCustomFieldFilterCard values={data?.data ?? []} customField={customField} {...props} />;
});

PrivateCustomFieldFilterCard.displayName = 'CustomFieldFilterCard';
